module.exports = __webpack_public_path__ + "static/image/audience-guide5.svg?af865924ea879ea508001386c6a60c92";